import {api} from 'app/services/api';
import {changeHeaderText} from 'app/actions/headerActions';
import {catchDataError} from 'app/helpers/apiHelpers';
import {updateHistory} from 'app/actions/historyActions';
import {updateHttpError} from 'app/components/error/ErrorHandlerActions';
import {DistrictChangeParentFactory} from 'app/models/appBar/DistrictChangeParentFactory';
import {DistrictUnsetParentFactory} from 'app/models/appBar/DistrictUnsetParentFactory';

const getRegions = () => {
  return api.get(`/regions`);
};

const getDistricts = regionSlug => {
  return api.get(`/districts?region=${regionSlug}&additionalFields=brandings,ivw`);
};

function fetchingRegions() {
  return {
    type: 'REGIONS_FETCHING',
  };
}

function updateRegions(data) {
  return {
    type: 'REGIONS_UPDATE',
    data,
  };
}

function setRegionSelectHeader(dispatch, district) {
  const parent = !district?.name ? DistrictUnsetParentFactory.create() : DistrictChangeParentFactory.create(district);

  dispatch(
    changeHeaderText({
      title: 'FuPa Regionsauswahl',
      parent,
    })
  );
}

function fetchRegionsSSR() {
  return getRegions()
    .then(response => response.data)
    .catch(error => Promise.reject(catchDataError(error)));
}

function fetchDistrictsSSR(slug) {
  return getDistricts(slug)
    .then(response => response.data)
    .catch(error => Promise.reject(catchDataError(error)));
}

function fetchRegionSelectPageSSR(slug) {
  return function (dispatch, getState) {
    const {district} = getState().session;
    setRegionSelectHeader(dispatch, district);

    const fetchRegionsResponse = fetchRegionsSSR();
    const fetchDistrictsResponse = slug ? fetchDistrictsSSR(slug) : Promise.resolve();

    return Promise.all([fetchRegionsResponse, fetchDistrictsResponse])
      .then(([regionsResponse, districtsResponse]) => {
        const districts = districtsResponse ? {[slug]: {items: districtsResponse, isFetching: false}} : {};
        dispatch(
          updateHistory('undefined', {
            store: 'RegionSelectPage',
            data: {
              regions: {isFetching: false, items: regionsResponse},
              districts,
            },
          })
        );
      })
      .catch(error => {
        dispatch(updateHttpError(error));
      });
  };
}

function fetchRegions(district, dispatchRedux) {
  return function (dispatch, state) {
    setRegionSelectHeader(dispatchRedux, district);
    const {items} = state.regions;
    if (items.length > 0) {
      return;
    }
    dispatch(fetchingRegions());
    return getRegions()
      .then(response => {
        dispatch(updateRegions(response.data));
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatch(updateHttpError(errorData));
      });
  };
}

function fetchingDistricts(data) {
  return {
    type: 'DISTRICTS_FETCHING',
    data,
  };
}

function updateDistricts(data) {
  return {
    type: 'DISTRICTS_UPDATE',
    data,
  };
}

function fetchDistricts(slug) {
  return function (dispatch, state) {
    if (!slug) {
      return;
    }
    const {districts} = state;
    if (slug in districts && districts[slug].items) {
      return;
    }
    dispatch(fetchingDistricts({key: slug}));
    return getDistricts(slug)
      .then(response => {
        dispatch(updateDistricts({key: slug, items: response.data}));
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatch(updateHttpError(errorData));
      });
  };
}

export {fetchRegionSelectPageSSR, fetchRegions, fetchDistricts, setRegionSelectHeader};
